import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonExitGreyedCatchRide = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 12,
	viewBox: "0 0 28 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M9.14286 11H2.85714V3.85L6.85714 0L7.57143 0.6875C7.63809 0.751667 7.69295 0.83875 7.736 0.94875C7.77905 1.05875 7.80038 1.16417 7.8 1.265V1.4575L7.17143 3.85H10.8571C11.1619 3.85 11.4286 3.96 11.6571 4.18C11.8857 4.4 12 4.65667 12 4.95V6.05C12 6.11417 11.9905 6.18292 11.9714 6.25625C11.9524 6.32958 11.9333 6.39833 11.9143 6.4625L10.2 10.34C10.1143 10.5233 9.97143 10.6792 9.77143 10.8075C9.57143 10.9358 9.3619 11 9.14286 11ZM4 9.9H9.14286L10.8571 6.05V4.95H5.71429L6.48571 1.925L4 4.3175V9.9ZM2.85714 3.85V4.95H1.14286V9.9H2.85714V11H0V3.85H2.85714Z",
			fill: "#9E9E9E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1945 10L15.9983 0.999999L26.3906 1L21.1945 10Z",
			fill: "#9E9E9E"
		})
	]
});
const ForwardRef = forwardRef(SvgPersonExitGreyedCatchRide);
export { ForwardRef as ReactComponent };
